export const projectsData = [
  { 
    title: 'Blackjack',
    description: 'A browser based Blackjack game. Created using HTML, CSS, and JavaScript',
    image: '/screenshot.jpeg',
    repositoryLink: 'https://github.com/jpastine/blackjack.git',
    deploymentLink: 'https://jpblackjack.netlify.app/',
  },
  
  {
    title: 'Team Manager',
    description: 'Full CRUD application that allows a user to create teams and players, and update player stats throughout the season',
    image: '/teammanager.png',
    repositoryLink: 'https://github.com/jpastine/team-manager.git',
    deploymentLink: 'https://team-manager.fly.dev/'
  },

  {
    title: 'Exchange-O-Gram',
    description: 'MERN stack application that allows users to share images with other users. Images can be liked and commented on by other users.',
    image: '/screenshot.PNG',
    repositoryLink: 'https://github.com/jpastine/exchangeagram-front-end',
    deploymentLink: 'https://exchangeagram.netlify.app/'
  },
]


